import React from "react"

const Privacy=()=>{
   return (
     <h1>Privacy</h1>
   )
}

export default Privacy